import { FileUpload } from '@roc/ui';
import { observer } from 'mobx-react';
import { CloudUpload, InsertDriveFileOutlined, Delete } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Box, Typography } from '@material-ui/core';


const useUploadStyles = makeStyles(theme => ({
  uploadButton: {
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#EAF4FA',
    width: '100%',
  },
  uploadButtonContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  uploadIcon: {
    marginRight: '12px',
  },
  uploadText: {
    '& .MuiTypography-body1': {
      fontSize: '14px',
    },
    fontSize: '14px',
  },
}));

export const FileUploadButton = observer(
  ({ label, onUpload, onRemove, uploadedFile, formats }: {
    label: any; onUpload: (file: FileUpload) => void;
    onRemove: (file: FileUpload) => void; uploadedFile: FileUpload; formats?: string
  }) => {
    const classes = useUploadStyles();

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        onUpload({ name: file.name, file });
      }
    };

    return (
      <Box>
        {<Paper className={classes.uploadButton} elevation={0}>
          {uploadedFile ?
            <Box className={classes.uploadButtonContent} justifyContent={'space-between'}>
              <Box display={'flex'}>
                <InsertDriveFileOutlined className={classes.uploadIcon} />
                <Typography className={classes.uploadText}>{uploadedFile.name}</Typography>
              </Box>
              <Delete color='error' style={{ cursor: 'pointer' }} onClick={() => onRemove(uploadedFile)} />
            </Box> :
            <>
              <input
                type="file"
                accept={formats}
                id={`upload-${label}`}
                style={{ display: 'none', cursor: 'pointer' }}
                onChange={handleFileSelect}
              />
              <label htmlFor={`upload-${label}`}>
                <Box className={classes.uploadButtonContent} style={{ cursor: 'pointer' }}>
                  <CloudUpload color='primary' className={classes.uploadIcon} />
                  <Typography className={classes.uploadText}>{label}</Typography>
                </Box>
              </label>
            </>}
        </Paper>
        }
      </Box>
    );
  }
);